<article id="htmlData" #pdfElement>
    <div class="row">
        <div class="col-md-9">
            <img width="230px" height="72px" style="opacity: 0.6; margin-bottom: 20px;" src="../../../../../../../assets/images/logos/dark-logo.png">
        </div>

        <div class="col-md-3">
            <div style="display: flex; flex-direction: column;">
                <div>
                    <qrcode                         
                        [qrdata]="myAngularxQrCode" 
                        [width]="150" 
                        [imageSrc]="'../../../../../../../assets/images/logos/logo-inge-fondo.jpg'"
                        [imageHeight]="32"
                        [imageWidth]="32"
                        [errorCorrectionLevel]="'M'">
                    </qrcode>
                </div>
                <div>
                    <p>N° Minuta: {{nminute}}</p>
                </div>
            </div>
        </div>
    </div>

    <h3>Informacion del Cliente</h3>
    <article class="container">
        <div class="section">
            <div class="property">
                <label>Nombre:</label> <span>{{ minuteRequestClient?.name || '-' }}</span>
            </div>
            <div class="property">
                <label>RUT:</label> <span>{{ minuteRequestClient?.fullRut || '-' }}</span>
            </div>
            <div class="property">
                <label>Email:</label> <span>{{ minuteRequestClient?.email || '-' }}</span>
            </div>
            <div class="property">
                <label>Telefono:</label> <span>{{ minuteRequestClient?.phone || '-' }}</span>
            </div>
            <div class="property">
                <label>Web:</label> <span>{{ minuteRequestClient?.website || '-' }}</span>
            </div>
        </div>

        <div class="section">
            <div class="property">
                <label>Actividad Economica:</label> <span>{{ minuteRequestClient?.currentEconomicActivity || '-' }}</span>
            </div>
            <div class="property">
                <label>Direccion Particular:</label> <span>{{ minuteRequestClient?.address }}</span>
            </div>
            <div class="property">
                <label>Fecha Creacion de minuta:</label> <span>{{ minuteRequestRealTime?.createdAt | date : "dd/MM/yyyy " : '-06:00' }}-{{ minuteRequestRealTime?.createdAt | date:'shortTime':'-06:00'}} Hrs</span>
            </div>
            <div class="property">
                <label>Fecha Expiracion:</label> <span>{{ minuteRequestRealTime?.dueDate | date : "dd/MM/yyyy " : '-06:00' }}</span>
            </div>
        </div>
    </article>


    <section class="desc_line">
        <div>
            <h3>Resumen Informativo</h3>
            <article class="container">
                <section>
                    <div class="property">
                        <label>Riesgo a Alcanzar:</label> 
                        <span>
                            {{ 
                                originalFactoringOperation?.financedAmount
                                ? ( originalFactoringOperation.financedAmount
                                | currency:'CLP':'symbol')
                                : "-"
                            }}
                        </span>
                    </div>
                    <div class="property">
                        <label>Fecha inicio actividades:</label> 
                        <span> 
                            {{
                                minuteRequestClient?.startCurrentActivity
                                ? (minuteRequestClient.startCurrentActivity
                                | date : "dd-MM-yyyy")
                                : "-"
                            }}
                        </span>
                    </div>
                </section>
                <section>
                    <div class="property">
                        <label>Cliente Inge:</label> 
                        <span>
                            {{ minuteRequestClient?.ingeClient ? "Sí" : "No" }}

                        </span>
                    </div>
                    <div class="property">
                        <label>N° Factura Formula:</label> 
                        <span>
                            {{ 
                                minuteRequestClient?.invoicesTransferFormula | number
                            }}
                        </span>
                    </div>
                </section>
                <section>
                    <div class="property">
                        <label>N° Operaciones SAGR:</label> 
                        <span>
                            {{minuteRequestClient?.warrantyOperations | number}}
                        </span>
                    </div>
                </section>
            </article>
        </div>
    </section>

    <div class="container_general">
        <h3>Descripción de la Minuta</h3> 
        <article class="container">
            <section class="MinuteDescription" style="margin-bottom: 10px;">
                <span> 
                    {{
                        minuteRequestRealTime?.description
                        ? minuteRequestRealTime.description
                        : "No ha Incluido una descripción"
                    }} 
                </span>
            </section>
        </article>
    </div>

    <div class="container_general">
        <h3>Socios</h3>
        <div class="section">
            <table>
                <thead>
                    <tr>
                        <th scope="col">Nombre</th>
                        <th scope="col">Rut</th>
                        <th scope="col">Participacion</th>
                        <th scope="col">Estado Civil</th>
                        <th scope="col">Edad</th>
                        <th scope="col">Aval</th>
                        <th scope="col">RL</th>
                        <th scope="col">Dicom</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let debtor of minuteOwnersRequest">
                        <td scope="row">{{ debtor.name ? debtor.name : '-' }}</td>
                        <td> {{ debtor.fullRut }} </td>
                        <td> {{ debtor.participation ? debtor.participation + '%' : '-' }} </td>
                        <td> {{ debtor.civilState ? debtor.civilState : '-' }} </td>
                        <td> {{ debtor.age ? debtor.age : '-' }} </td>
                        <td> {{ debtor.aval ? "Sí" : "No" }} </td>
                        <td> {{ debtor.rl ? "Sí" : "No" }} </td>
                        <td [class.red] = "debtor?.dicom > 0"> {{ debtor?.dicom ? (debtor.dicom | currency : "CLP" : "symbol") : "$0" }} </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="container_general" id="finPage1">
        <h3>Cliente Factoring</h3>
        <div *ngIf="minuteRequestClient?.factoringClient; else noClienteFactoring">
            <article class="container">
                <div class="property">
                    <label>Facturas cedidas:</label>
                     <span> 
                        {{ minuteRequestClient?.invoicesTransferFormula | number }}
                    </span>
                </div>
                <div class="property">
                    <label>Monto total cedido:</label>
                     <span> 
                        {{ minuteRequestClient?.invoicesTransferFormulaAmount ? ( minuteRequestClient.invoicesTransferFormulaAmount | currency : "CLP" : "symbol") : "$0" }}
                    </span>
                </div>

                <div class="property">
                    <label>Línea solicitada:</label>
                     <span> 
                        {{ minuteRequestRealTime?.factoringLine | currency : "CLP" : "symbol" }}
                    </span>
                </div>

            </article>
        </div>
        <ng-template #noClienteFactoring>
            <mat-card-content>
                <p>No es cliente Factoring</p>
                </mat-card-content>
        </ng-template>
    </div>

    <div class="container_general">
        <section id="ClienteSAGR" class="subcontainer">
            <h3>Cliente SAGR</h3>
            <div *ngIf="minuteRequestClient?.ingeClient; else noClienteSAGR">
              <article class="container">

                <div class="property">
                    <label>Fecha de creación:</label>
                     <span> 
                        {{ this.minuteRequestClient.legacyData.inserted | date : "dd-MM-yyyy" }}
                    </span>
                </div>

                <div class="property">
                    <label>Ejecutivo:</label>
                     <span> 
                        {{ this.minuteRequestClient.legacyData.executive }}
                    </span>
                </div>

                <div class="property">
                    <label>Último scoring:</label>
                     <span> 
                        {{ this.minuteRequestClient.legacyData.lastScoringStateDescription }}
                    </span>
                </div>

                <div class="property">
                    <label>Riesgo total asumido:</label>
                     <span> 
                        {{ this.minuteRequestClient.legacyData.totalRiskTaken | currency : "CLP" : "symbol" }}
                    </span>
                </div>

                <div class="property">
                    <label>Cantidad total de garantías:</label>
                     <span> 
                        {{ this.minuteRequestClient.legacyData.totalWarrantiesCount | number }}
                    </span>
                </div>

                <div class="property">
                    <label>Cantidad total de garantías:</label>
                     <span> 
                        {{ this.minuteRequestClient.legacyData.totalWarrantiesCount | number }}
                    </span>
                </div>

                <div class="property">
                    <label>Línea:</label>
                     <span> 
                        {{ this.minuteRequestClient.legacyData.linea | currency : "CLP" : "symbol" }}
                    </span>
                </div>

                <div class="property">
                    <label>Línea disponible:</label>
                     <span> 
                        {{ this.minuteRequestClient.legacyData.availableLine | currency : "CLP" : "symbol" }}
                    </span>
                </div>

                <div class="property">
                    <label>Línea total utilizada:</label>
                     <span> 
                        {{ this.minuteRequestClient.legacyData.totalUsedLine | currency : "CLP" : "symbol" }}
                    </span>
                </div>

                <div class="property">
                    <label>Nueva línea solicitada:</label>
                     <span> 
                        {{ minuteRequestRealTime?.warrantyLine | currency : "CLP" : "symbol" }}
                    </span>
                </div>

                <div class="property">
                    <label>Garantías vigentes:</label>
                     <span> 
                        {{ this.minuteRequestClient.legacyData.availableWarrantiesCount | number }}
                    </span>
                </div>

              </article>
            </div>
            <ng-template #noClienteSAGR>
              <mat-card-content>
                <p>No es cliente SAGR</p>
              </mat-card-content>
            </ng-template>
        </section>
    </div>

    <div class="container_general">
        <h3>Mercado público</h3>
            <article class="container">
                <div class="property">
                    <label>Fecha de inicio en MP:</label>
                    <span> 
                        {{ minuteRequestClient?.legacyData?.startDate ? (minuteRequestClient.legacyData.startDate | date : "dd-MM-yyyy") : "-" }}
                    </span>
                </div>

                <div class="property">
                    <label>Adjudicación máxima:</label>
                    <span> 
                        {{ minuteRequestClient?.legacyData ? (minuteRequestClient.legacyData.maxAdjudication | currency : "CLP" : "symbol") : "-" }}
                    </span>
                </div>

                <div class="property">
                    <label>Primera adjudicación:</label>
                    <span> 
                        {{ minuteRequestClient?.legacyData ? (minuteRequestClient.legacyData.firstAdjudication | date : "dd-MM-yyyy") : "-" }}
                    </span>
                </div>

                <div class="property">
                    <label>1ra adjudicación hace:</label>
                    <span> 
                        {{ minuteRequestClient?.legacyData ? (minuteRequestClient.legacyData.firstAdjudicationFromNow | number) + ' Dias' : "-" }}
                    </span>
                </div>
            </article>
    </div>

    <div class="container_general">
        <h3>TGR</h3>
            <article class="container" *ngIf="minuteRequestClient?.tgr ; else noTgr">
                <div class="property">
                    <label>Monto deuda:</label>
                    <span> 
                        {{ minuteRequestClient?.tgr?.amount | currency : "CLP" : "symbol" }}
                    </span>
                </div>
    
                <div class="property">
                    <label>Fecha deuda:</label>
                    <span> 
                        {{ minuteRequestClient?.tgr?.date | date : "dd-MM-yyyy" }}
                    </span>
                </div>
    
                <div class="property">
                    <label>Convenio:</label>
                    <span> 
                        {{ minuteRequestClient?.tgr?.agreement ? 'Activo' : 'Sin Convenio'}}
                    </span>
                </div>
            </article>
            <ng-template #noTgr>
                <mat-card-content>
                  <p>Sin Deuda TGR</p>
                </mat-card-content>
            </ng-template>
    </div>

    <div class="container_general">
        <h3>CMF</h3>
        <article class="container" *ngIf="minuteRequestClient?.cmf ; noCMF">
            <div class="property">
                <label>Monto deuda:</label>
                <span> 
                    {{ minuteRequestClient?.cmf?.debtAmount | currency : "CLP" : "symbol" }}
                </span>
            </div>
            <div class="property">
                <label>Fecha deuda:</label>
                <span> 
                    {{ minuteRequestClient?.cmf?.debtDate | date : "dd-MM-yyyy"}}
                </span>
            </div>
            <div class="property">
                <label>Pagada:</label>
                <span> 
                    {{ minuteRequestClient?.cmf?.payCmf ? 'Pagada' : 'No Pagada'}}
                </span>
            </div>
        </article>
        <ng-template #noCMF>
            <mat-card-content>
                <p>Sin Deuda CMF</p>
            </mat-card-content>
        </ng-template>
    </div>

    <div class="container_general">
        <h3>Fogape</h3>
        <div *ngIf="minuteRequestClient?.fogape">
            <article class="container">
                <div class="property">
                    <label>Elegible:</label>
                    <span> 
                        <span>{{ minuteRequestClient?.fogape ? "Sí" : "No" }}</span>
                    </span>
                </div>
    
                <div class="property">
                    <label>Deuda:</label>
                    <span> 
                        <span>{{ minuteRequestClient?.deudaFogape }}UF</span>
                    </span>
                </div>
            </article>
        </div>
        <div *ngIf="!minuteRequestClient?.fogape"> <span>Sin informacion Fogape</span> </div>
    </div>

    <div class="container_general">
        <h3>Dicom</h3>
        <div *ngIf="minuteRequestClient?.dicom">
            <article class="container">
                <div class="property">
                    <label>Monto deuda:</label>
                    <span> 
                        {{ minuteRequestClient?.dicom?.deudaDicom | currency : "CLP" : "symbol" }}
                    </span>
                </div>
    
                <div class="property">
                    <label>Fecha consulta:</label>
                    <span> 
                        {{ minuteRequestClient?.dicom?.dateConsultaDicom | date : "dd-MM-yyyy"}}
                    </span>
                </div>
            </article>
        </div>
        <div *ngIf="!minuteRequestClient?.dicom"> <span>Sin informacion Dicom</span> </div>
    </div>

    <div class="container_general" id="finPage2">
        <h3>SII</h3> 
        <article class="container">
            <div class="property">
                <label>Cliente enrolado:</label>
                <span> 
                    {{ minuteRequestClient?.siiConnected ? "Sí" : "No" }}
                </span>
            </div>

            <div class="property">
                <label>Nº de facturas:</label>
                <span> 
                    {{ minuteRequestClient?.sellInvoices ? (minuteRequestClient?.sellInvoices | number) : "Sin informacion" }}
                </span>
            </div>
            <div class="property">
                <label>Es PYME:</label>
                <span>
                    {{ minuteRequestClient?.isPyme ? "Sí" :"No"}}
                </span>
            </div>
        </article>
    </div>

    <div class="container_general">
        <h3>Operaciones</h3>
        <article class="container">
            <table>
                <thead>
                    <tr>
                        <th scope="col">Folio</th>
                        <th scope="col">Nombre</th>
                        <th scope="col">Rut</th>
                        <th scope="col">Monto Factura</th>
                        <th scope="col">Finaciado</th>
                        <th scope="col">Tasa</th>
                        <th scope="col">Tasa Total</th>
                        <th scope="col">Estado</th>
                        <th scope="col">Plazo</th>
                        <th scope="col">Comentario</th>
                    </tr>
                </thead>
                <tbody *ngIf="minuteRequestRealTime?.operations.length > 0; else noDataOperations">
                    <tr *ngFor="let operacion of minuteRequestRealTime?.operations">
                        <td>{{ operacion.folio }}</td>
                        <td>{{ operacion.debtorName }}</td>
                        <td>{{ operacion.debtorRut }}</td>
                        <td>{{ operacion.invoiceTotalAmount }}</td>
                        <td>{{ operacion.financedAmount }}</td>
                        <td>{{ operacion.rate }}</td>
                        <td>{{ operacion.allInRate }}</td>
                        <td>{{ operacion.operationState }}</td>
                        <td>{{ operacion.plazo }}</td>
                        <td>{{ operacion.comment }}</td>
                    </tr> <!--{{ debtor.resolutionStateName }}-->
                </tbody>
                <ng-template #noDataOperations>
                    <tr>
                        <td colspan="10">Sin Operaciones a Evaluar</td>
                    </tr>
                </ng-template>
            </table>
        </article>
    </div>

    <div class="container_general">
        <h3>Ordenes de Compra</h3>
        <article class="container">
            <table>
                <thead>
                    <tr>
                        <th scope="col">Folio</th>
                        <th scope="col">Codigo</th>
                        <th scope="col">Fecha de Emision</th>
                        <th scope="col">Monto</th>
                        <th scope="col">Plazo</th>
                        <th scope="col">SIGFE</th>
                    </tr>
                </thead>
                <tbody *ngIf="operations?.buyOrder != null ; else noDataOrder">
                    <tr *ngFor="let orden of operations">
                        <td>{{ orden.folio }}</td>
                        <td>{{ orden.buyOrder.code }}</td>
                        <td>{{ orden.buyOrder.fechaEmision | date : "dd-MM-yyyy" }}</td>
                        <td>{{ orden.buyOrder.amount | currency:'CLP':'symbol' }}</td>
                        <td>{{ orden.buyOrder.plazo }}</td>
                        <td *ngIf="orden.buyOrder.sigfe"> <fa-icon size="1x" [icon]="iconAproved" style="color: green;"> </fa-icon> </td>
                        <td *ngIf="!orden.buyOrder.sigfe"> <fa-icon size="1x" [icon]="iconReject" style="color: red;"> </fa-icon></td>
                    </tr>
                </tbody>
                <ng-template #noDataOrder>
                    <tr>
                        <td colspan="10">Sin Ordenes de Compra</td>
                    </tr>
                </ng-template>
            </table>
        </article>
    </div>

    <div class="container_general">
        <h3>Deudores</h3>
        <table>
            <thead>
                <tr>
                    <th scope="col">Nombre</th>
                    <th scope="col">Rut</th>
                    <th scope="col">N° Facturas</th>
                    <th scope="col">N° Notas de Credito</th>
                    <th scope="col">Monto Total</th>
                    <th scope="col">Resolucion</th>
                </tr>
            </thead>
            <tbody *ngIf="minuteDebtors.length > 0; else noDataResolution">
                <tr *ngFor="let debtor of minuteDebtors">
                    <td>{{ debtor.name }}</td>
                    <td>{{ debtor.fullRut }}</td>
                    <td>{{ debtor.buyInvoices }}</td>
                    <td>{{ debtor.receivedCreditNotes }}</td>
                    <td>{{ debtor.buyInvoiceTotalAmount | currency:'CLP':'symbol' }}</td>
                    <td *ngIf="debtor.resolutionStateName=='Aprobado'"> <fa-icon size="1x" [icon]="iconAproved" style="color: green;"> </fa-icon> </td>
                    <td *ngIf="debtor.resolutionStateName=='Rechazado'"> <fa-icon size="1x" [icon]="iconReject" style="color: red;"> </fa-icon></td>
                </tr> 
            </tbody>
            <ng-template #noDataResolution>
                <tr>
                    <td colspan="4">No se encontraron resoluciónes</td>
                </tr>
            </ng-template>
        </table>
    </div>

    <div class="container_general" id="finPage3">
        <h3>Top 10 Deudores</h3>
        <table>
            <thead>
                <tr>
                    <th scope="col">Nombre</th>
                    <th scope="col" style="width: 200px;">Rut</th>
                    <th scope="col">Monto Total de Ventas</th>
                    <th scope="col">Facturas</th>
                    <th scope="col">Monto Total Cedido</th>
                    <th scope="col">Facturas Cedidas</th>
                </tr>
            </thead>
            <tbody *ngIf=" minuteRequestKpi.debtorsTop10.length > 0; else noDataInvoces">
                <tr *ngFor="let debtor of minuteRequestKpi.debtorsTop10">
                    <td style="text-transform: uppercase;">{{ debtor.debtorName }}</td>
                    <td>{{ debtor.debtorRut }}</td>
                    <td>{{ debtor.sellInvoiceTotalAmount | currency:'CLP':'symbol' }}</td>
                    <td>{{ debtor.numSellInvoices }}</td>
                    <td>{{ debtor.transferInvoiceTotalAmount | currency:'CLP':'symbol' }}</td>
                    <td>{{ debtor.numTransferInvoices }}</td>
                </tr>
            </tbody>
            <ng-template #noDataInvoces>
                <tr>
                    <td colspan="4">Sin Información</td>
                </tr>
            </ng-template>
        </table>
    </div>

    <div class="row">
        <div class="col-6">
            <div class="container_general">
                <h3>12 Meses</h3>
                <table class="probandoTamanoFuente">
                    <thead>
                        <tr>
                            <th scope="col">Razon Social</th>
                            <th scope="col">Rut</th>
                            <th scope="col">Ventas</th>
                            <th scope="col">Compras</th>
                        </tr>
                    </thead>
                    <tbody *ngIf=" minuteRequestKpi.debtorsTop10.length > 0; else noDataInvoces">
                        <tr *ngFor="let debtor of minuteRequestKpi.debtorsLast12Months">
                            <td>{{ debtor.debtorName }}</td>
                            <td>{{ debtor.debtorRut }}</td>
                            <td>{{ debtor.sellInvoiceTotalAmount | currency:'CLP':'symbol' }}</td>
                            <td>{{ debtor.buyInvoiceTotalAmount | currency:'CLP':'symbol' }}</td>
                        </tr>
                    </tbody>
                    <ng-template #noDataInvoces>
                        <tr>
                            <td colspan="4">Sin Información</td>
                        </tr>
                    </ng-template>
                </table>
            </div>
        </div>

        <div class="col-6">
            <div class="container_general">
                <h3>24 Meses</h3>
                <table class="probandoTamanoFuente">
                    <thead>
                        <tr>
                            <th scope="col">Razon Social</th>
                            <th scope="col">Rut</th>
                            <th scope="col">Ventas</th>
                            <th scope="col">Compras</th>
                        </tr>
                    </thead>
                    <tbody *ngIf=" minuteRequestKpi.debtorsTop10.length > 0; else noDataInvoces">
                        <tr *ngFor="let debtor of minuteRequestKpi.debtorsLast24Months">
                            <td>{{ debtor.debtorName }}</td>
                            <td>{{ debtor.debtorRut }}</td>
                            <td>{{ debtor.sellInvoiceTotalAmount | currency:'CLP':'symbol' }}</td>
                            <td>{{ debtor.buyInvoiceTotalAmount | currency:'CLP':'symbol' }}</td>
                        </tr>
                    </tbody>
                    <ng-template #noDataInvoces>
                        <tr>
                            <td colspan="4">Sin Información</td>
                        </tr>
                    </ng-template>
                </table>
            </div>
        </div>
    </div>

    <div class="section container_general">
        <h3>
            Factorizaciones por factoring
        </h3>
        <table *ngIf="minuteRequestKpi.factoringByCesionarios.length > 0; else noDataFactoring">
            <thead>
                <tr>
                    <th scope="col">Nombre Cliente</th>
                    <th scope="col">Rut</th>
                    <th scope="col">Monto Facturas</th>
                    <th scope="col">Documentos</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let debtor of minuteRequestKpi.factoringByCesionarios">
                    <td> {{ debtor.cesionarioName }} </td>
                    <td> {{ debtor.cesionarioRut }} </td>
                    <td> {{ debtor.transferedInvoiceTotalAmount | currency:'CLP':'symbol' }} </td>
                    <td> {{ debtor.numTransferedInvoices | number }} </td>
                </tr>
            </tbody>
        </table>
        <ng-template #noDataFactoring>
            <div>
                <article class="container">
                    <span>Sin Factoring</span>
                 </article>
            </div>
        </ng-template>
    </div>

    <section class="section_approve">
    <h3>Aprobaciones:</h3>
        <div class="row">
            <div *ngFor="let resolution of minuteRequestRealTime?.resolutions" class="col-md-6 section_info_approve">
                <app-minute-resolution-item
                    [minuteResolution]="resolution"
                ></app-minute-resolution-item>
            </div>
        </div>
    </section>

    <div class="section container_general">
        <article class="container">
            <div class="property">
                <label>Resolución:</label>
                <span>
                    {{ minuteRequestRealTime?.finalResolutionName }}
                </span>
            </div>
            <div class="property" *ngIf="this.minuteRequestRealTime?.resolutedAt != null">
                <label>Fecha Resolución:</label>
                <span> 
                    {{ minuteRequestRealTime?.resolutedAt | date : "dd-MM-yyyy" }} 
                </span>
            </div>
        </article>
    </div>

    <div style="display: flex; justify-content: center;" data-html2canvas-ignore="true">
        <button mat-raised-button color="primary" (click)="createPdf()">Exportar PDF</button>
    </div>

    <div data-html2canvas-ignore="true">
        <button
          class="d-flex align-items-center m-y-32"
          type="button"
          mat-stroked-button
          color="primary"
          (click)="volver()"
        >
          <span class="span_back">
            <i-tabler name="chevron-left" class="m-r-8"></i-tabler>
            <span>Volver</span>
          </span>
        </button>
    </div>
</article>